var _g, _path, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1642 50C32.1017 50.1172 28.4298 51.875 25.8127 55H20.5783C16.6721 55 13.0002 53.125 13.0002 48.7891C13.0002 45.625 12.8831 35 17.844 35C18.6643 35 22.7267 38.3203 28.0001 38.3203C29.797 38.3203 31.5157 38.0078 33.1954 37.4219C33.0782 38.2812 33.0001 39.1406 33.0001 40C33.0001 43.5547 34.1329 47.0703 36.1642 50ZM77.9998 74.8828C77.9998 81.2109 73.8202 85 67.5702 85H33.4298C27.1798 85 23.0002 81.2109 23.0002 74.8828C23.0002 66.0547 25.0705 52.5 36.5157 52.5C37.8438 52.5 42.6875 57.9297 50.5 57.9297C58.3125 57.9297 63.1562 52.5 64.4843 52.5C75.9295 52.5 77.9998 66.0547 77.9998 74.8828ZM38.0001 25C38.0001 30.5078 33.5079 35 28.0001 35C22.4924 35 18.0002 30.5078 18.0002 25C18.0002 19.4922 22.4924 15 28.0001 15C33.5079 15 38.0001 19.4922 38.0001 25ZM65.4999 40C65.4999 48.2812 58.7812 55 50.5 55C42.2188 55 35.5001 48.2812 35.5001 40C35.5001 31.7188 42.2188 25 50.5 25C58.7812 25 65.4999 31.7188 65.4999 40ZM87.9998 48.7891C87.9998 53.125 84.3279 55 80.4217 55H75.1873C72.5702 51.875 68.8983 50.1172 64.8358 50C66.8671 47.0703 67.9999 43.5547 67.9999 40C67.9999 39.1406 67.9218 38.2812 67.8046 37.4219C69.4843 38.0078 71.203 38.3203 72.9999 38.3203C78.2733 38.3203 82.3357 35 83.156 35C88.117 35 87.9998 45.625 87.9998 48.7891ZM82.9998 25C82.9998 30.5078 78.5076 35 72.9999 35C67.4921 35 62.9999 30.5078 62.9999 25C62.9999 19.4922 67.4921 15 72.9999 15C78.5076 15 82.9998 19.4922 82.9998 25Z",
    fill: "#E5E5E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 15,
    width: 75,
    height: 70
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1642 50C32.1017 50.1172 28.4298 51.875 25.8127 55H20.5783C16.6721 55 13.0002 53.125 13.0002 48.7891C13.0002 45.625 12.8831 35 17.844 35C18.6643 35 22.7267 38.3203 28.0001 38.3203C29.797 38.3203 31.5157 38.0078 33.1954 37.4219C33.0782 38.2812 33.0001 39.1406 33.0001 40C33.0001 43.5547 34.1329 47.0703 36.1642 50ZM77.9998 74.8828C77.9998 81.2109 73.8202 85 67.5702 85H33.4298C27.1798 85 23.0002 81.2109 23.0002 74.8828C23.0002 66.0547 25.0705 52.5 36.5157 52.5C37.8438 52.5 42.6875 57.9297 50.5 57.9297C58.3125 57.9297 63.1562 52.5 64.4843 52.5C75.9295 52.5 77.9998 66.0547 77.9998 74.8828ZM38.0001 25C38.0001 30.5078 33.5079 35 28.0001 35C22.4924 35 18.0002 30.5078 18.0002 25C18.0002 19.4922 22.4924 15 28.0001 15C33.5079 15 38.0001 19.4922 38.0001 25ZM65.4999 40C65.4999 48.2812 58.7812 55 50.5 55C42.2188 55 35.5001 48.2812 35.5001 40C35.5001 31.7188 42.2188 25 50.5 25C58.7812 25 65.4999 31.7188 65.4999 40ZM87.9998 48.7891C87.9998 53.125 84.3279 55 80.4217 55H75.1873C72.5702 51.875 68.8983 50.1172 64.8358 50C66.8671 47.0703 67.9999 43.5547 67.9999 40C67.9999 39.1406 67.9218 38.2812 67.8046 37.4219C69.4843 38.0078 71.203 38.3203 72.9999 38.3203C78.2733 38.3203 82.3357 35 83.156 35C88.117 35 87.9998 45.625 87.9998 48.7891ZM82.9998 25C82.9998 30.5078 78.5076 35 72.9999 35C67.4921 35 62.9999 30.5078 62.9999 25C62.9999 19.4922 67.4921 15 72.9999 15C78.5076 15 82.9998 19.4922 82.9998 25Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 13,
    y: 15,
    width: 76,
    height: 71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyEvent);
export default __webpack_public_path__ + "static/media/emptyEvent.68d20e2bdf3b408ef6cbefeacd9214a9.svg";
export { ForwardRef as ReactComponent };